import LTR from "@brand-icons/ploom/accessories-front-pannel/accessories-front-pannel-ltr.svg";

import { iconFactory } from "../iconFactory";

export const AccessoriesFrontPannelIcon = iconFactory("AccessoriesFrontPannelIcon", LTR);
